import type { Comment } from '~/types/comment';

export interface CommentThreadNode extends Comment {
  parent: CommentThreadNode | null;
  replies: CommentThreadNode[];
}

export const parseComments = (comments: Comment[]) => {
  const rootNodes: CommentThreadNode[] = [];
  const nodesMap = comments.reduce<Record<string, CommentThreadNode>>((acc, comment) => {
    acc[comment.id] = {
      ...comment,
      parent: null,
      replies: [],
    };
    return acc;
  }, {});

  Object.values(nodesMap).forEach(node => {
    if (node.parent_id) {
      const parentNode = nodesMap[node.parent_id] as CommentThreadNode | undefined;

      if (parentNode) {
        node.parent = parentNode;
        node.parent.replies.push(node);
        // ascending order (oldest first):
        node.parent.replies.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
      }
    } else {
      rootNodes.push(node);
    }
  });

  return {
    rootNodes,
    nodesMap,
  };
};
